"use client";

/**
 * ListSelection 컴포넌트
 * @description 목록에서 하나를 고르는 행. 앱 DS `ListSelection` 의 웹 포팅.
 * @example
 * <ListSelection title="Korea" selected={value === "KR"} onSelect={() => pick("KR")} />
 */
import { memo } from "react";

import { listSelectionStyles } from "./ListSelection.styles";
import type { ListSelectionProps } from "./ListSelection.types";

const ListSelection = memo<ListSelectionProps>(
  ({ title, selected, onSelect }) => (
    <button
      type="button"
      role="option"
      aria-selected={selected}
      onClick={onSelect}
      className={listSelectionStyles.root({ selected })}
    >
      <span className={listSelectionStyles.title}>{title}</span>
      <span aria-hidden className={listSelectionStyles.mark({ selected })} />
    </button>
  ),
);

ListSelection.displayName = "ListSelection";

export default ListSelection;
